export default __webpack_public_path__ + "static/media/hand_over_computer.fbf9f8fd.jpg";